import { render } from "./FormularioUnidade.vue?vue&type=template&id=ac638850"
import script from "./FormularioUnidade.vue?vue&type=script&lang=js"
export * from "./FormularioUnidade.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__